export const ACTION_CODE = 'USER_ACTION';
